import { Link } from 'react-router-dom';
import ClaireoaksLogo from '../ClaireoaksLogo';
import { EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';

const Footer = () => {
  const explore = [
    { name: 'About', href: '/about' },
    { name: 'Products', href: '/products' },
    { name: 'Contact', href: '/contact' },
    { name: 'Sign in', href: '/login' },
  ];

  const products = [
    { name: 'Checking', href: '/products' },
    { name: 'Savings', href: '/products' },
    { name: 'Loans', href: '/products' },
    { name: 'Mortgages', href: '/products' },
  ];

  return (
    <footer className="relative overflow-hidden bg-oak-950 text-oak-100">
      <div className="pointer-events-none absolute inset-0 bg-pattern-canopy opacity-60" />

      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <ClaireoaksLogo light />
            <p className="mt-6 max-w-sm text-base leading-relaxed text-oak-300">
              Clear banking, rooted in community. A member-owned cooperative serving families and
              neighborhoods since 1973.
            </p>
            <p className="mt-6 text-sm text-oak-400">Federally insured by NCUA · Equal Housing Lender</p>
          </div>

          <div className="grid gap-10 sm:grid-cols-3 lg:col-span-7">
            <div>
              <h3 className="font-display text-lg text-white">Explore</h3>
              <ul className="mt-4 space-y-3">
                {explore.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-oak-300 transition hover:text-claire-300">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-display text-lg text-white">Accounts</h3>
              <ul className="mt-4 space-y-3">
                {products.map((product) => (
                  <li key={product.name}>
                    <Link to={product.href} className="text-oak-300 transition hover:text-claire-300">
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-display text-lg text-white">Visit</h3>
              <ul className="mt-4 space-y-3 text-oak-300">
                <li>
                  <a
                    href="mailto:support@claireoakscu.com"
                    className="flex items-start gap-2 transition hover:text-claire-300"
                  >
                    <EnvelopeIcon className="mt-0.5 h-5 w-5 shrink-0" />
                    support@claireoakscu.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.google.com/maps/search/6255+Carrsville+Hwy,+Carrsville,+VA+23315"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-2 transition hover:text-claire-300"
                  >
                    <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0" />
                    <span>6255 Carrsville Hwy, Carrsville, VA 23315</span>
                  </a>
                </li>
                <li className="text-sm text-oak-400">NMLS ID: 6488745</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-oak-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Claireoaks Credit Union</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <span>Routing: <span className="font-mono text-oak-300">021000021</span></span>
            <Link to="/contact" className="transition hover:text-claire-300">
              Privacy
            </Link>
            <Link to="/contact" className="transition hover:text-claire-300">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
